<template>
	<div class="box" style="">
		<div class="nav public-width width-auto flex">
			<div class="flex">
				<el-image class="logo" :src="log_src"></el-image>
				<h3 style="line-height: 80px;">岩亨信息技术有限公司</h3>
			</div>
			<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" >
				<el-menu-item index="1" @click="toPage('Index')"> 首页 </el-menu-item>
				<el-menu-item index="5" @click="toPage('ApplicationCase')">
					公司介绍
				</el-menu-item>
				<el-menu-item index="5" @click="toPage('ApplicationCase')">
					合作伙伴
				</el-menu-item>
			</el-menu>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeIndex: "1",
			activeIndex2: "1",
			log_src: require("@/assets/image/logo_img.jpg"),
		};
	},
	methods: {
		toPage(url) {
			if( url == 'Index' ){
				document.documentElement.scrollTop = 0;
			}else if( url == 'ProductCenter' ){
				document.documentElement.scrollTop = 600;
			}else if( url == 'Software' ){
				document.documentElement.scrollTop = 2200;
			}else if( url == 'ApplicationCase' ){
				document.documentElement.scrollTop = 2850;
			}
		},
	},
};
</script>

<style lang="less" scoped>
	.box{
		position: sticky;
		top: 0; 
		background-color: #fff;
		z-index: 999;
		border-bottom: 1px solid #eee;
		padding-left: 150px;
	}
	.el-menu--horizontal > .el-menu-item.is-active {
		border: 0px solid white;
	}
	.el-menu.el-menu--horizontal {
		border: none;
	}
	.el-menu--horizontal > .el-menu-item {
		margin: 0 30px;
	}
	.nav {
		display: flex;
		align-items: center;
		justify-content: start;
		font-weight: 600;
		padding: 10px 0;
		// logo大小
		.logo {
			width: 60px;
			height: 60px;
			margin-top: 10px;
			margin-right: 20px;
		}
		.tal {
			font-size: 14px;
			margin-left: 50px;
			color:  rgb(145, 145, 145);
			cursor: pointer;
		}
	}

</style>